import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "kas-cookie-consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-consent"
          className="fixed bottom-4 left-4 right-4 z-[55] mx-auto max-w-3xl rounded-2xl border border-slate-800 bg-[#111c33]/95 p-5 backdrop-blur-xl md:left-6"
        >
          <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-[#2563EB]" />
              <p className="text-sm leading-relaxed text-slate-300">
                We use cookies to enhance your browsing experience and analyse site traffic.
                By continuing, you agree to our use of cookies.
              </p>
            </div>
            <div className="flex shrink-0 gap-2">
              <button
                onClick={accept}
                data-testid="cookie-decline"
                className="rounded-full border border-slate-700 px-4 py-2 text-sm font-medium text-slate-300 transition-colors hover:bg-white/5"
              >
                Decline
              </button>
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="rounded-full bg-[#2563EB] px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#3b82f6]"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
